import doc                from '@widesk-core/decorators/doc';
import model              from '@widesk-core/decorators/model';
import FileServiceModel   from '@/models/FileServiceModel';
import FileStatusModel    from './FileStatusModel';
import MimeTypeModel      from './MimeTypeModel';
import TypeSourceModel    from './TypeSourceModel';

@model.urnResource('file')
@doc.path('/stonecode_file_files/{?id}')
export default class FileModel extends FileServiceModel {
	public declare _tsFilters: {
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'createdBy': id;
		'fileStatus': id;
		'fileStatus.reference': FileFileStatusReference;
		'typeSource': id;
		'typeSource.source': id;
		'typeSource.source.entityUrn': string;
		'typeSource.type': id;
		'typeSource.type.reference': FileTypeReference;
		'typeSource.type.service': id;
		'typeSource.type.service.serviceUrn': string;
	};

	public declare _tsSorts: {
		'id': string;
		'updatedAt': string;
		'createdAt': string;
	};

	@doc.string declare file: string;
	@doc.model(FileStatusModel) declare fileStatus: FileStatusModel;
	@doc.string declare label: string;
	@doc.model(MimeTypeModel) declare mimeType: MimeTypeModel;
	@doc.string declare name: string;
	@doc.string declare description: string;
	@doc.number declare size: number;
	@doc.model(TypeSourceModel) declare typeSource: TypeSourceModel;

	public get downloadPath(): string {
		return (this.isLoaded && !!this.id) ? this.get('@url') : '';
	}

	public get isImage() {
		return this.mimeType.reference.startsWith('image/');
	}

	public get typeSourceId(): id {
		return this.get('typeSource.id');
	}

	public get isPublic() {
		return !!this.get('public');
	}
}
